import styled from 'styled-components';
import { Form as FormOriginal } from 'formik';
import breakpoint from 'Styles/breakpoints';

import TextAreaOriginal from '../TextArea/TextArea';

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  height: 100%;

  ${breakpoint('medium')} {
    padding: 24px 16px;
    height: auto;
  }
`;

export const Form = styled(FormOriginal)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TextArea = styled(TextAreaOriginal)`
  margin-bottom: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint('medium')} {
    flex-direction: row;
  }
`;

export default {};
